import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BusinessEnabledOption, FocusInputType, LocalService } from '../../../service/local.service';
import { GetTokenDateFormat } from 'src/app/supporting/conversion';

@Component({
  selector: 'app-search-token',
  templateUrl: './search-token.component.html',
  styleUrls: ['./search-token.component.scss']
})
export class SearchTokenComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["search_token"]; @Input() businessId = ''; @Input() currentId = ''; @Input() isTitle = true;
  @Output() onSearchToken = new EventEmitter(); @Input() isEmitOnBlur = false; @Input() isShowValidationMessage = false; @Input() iconTopAdjust: number = 5;
  tokenDate: string = ''; tokenNumber: number = null; todayTokenDate: string = ''; message: string = ''; isTokenAvailable = false;
  elementIds: any = {
    txt_token_num: 'txt_token_num'
  };

  isShowAcceptanceSerailNumberInViewBill = false;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private router: Router, private billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    this.isShowAcceptanceSerailNumberInViewBill = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.ShowAcceptanceSerailNumberInViewBill);

    if (!this.isShowAcceptanceSerailNumberInViewBill) {
      const dateNow = this.localService.getDeviceDate();
      const tokenFormat = this.localService.getBusinessTokenFormatType(this.businessId);
      const tokenDateSplitter = this.localService.getTokenDateSplitter(this.businessId);
      this.todayTokenDate = GetTokenDateFormat(tokenFormat, dateNow, tokenDateSplitter);
      this.tokenDate = this.todayTokenDate;
    }
  }

  onGetToken(isForce = true) {
    this.message = '';
    if (this.currentId != '') {
      if (isForce) {
        this.onValidate(2);
        if (this.tokenNumber) {
          let token = this.tokenDate + '-' + this.tokenNumber;
          this.billingManagementService.getBillingIdByToken(this.businessId, token).subscribe(result => {
            if (result && result.key) {
              this.tokenNumber = null;
              if (result.key != this.currentId)
                this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, result.key]);
            }
          });
        }
      } else if (this.tokenNumber) {
        let decodedQrCode = this.localService.getDecodedQrCode(this.tokenNumber.toString());
        if (decodedQrCode.isValid) {
          this.tokenNumber = null;
          setTimeout(() => {
            this.tokenNumber = null;
            this.localService.onFocusNextInput(this.elementIds.txt_token_num, FocusInputType.TextBox);
          }, 100);
          if (decodedQrCode.value != this.currentId)
            this.router.navigate(['/billing' + this.localService.basicParamsString, decodedQrCode.businessId, decodedQrCode.value]);
        }
      }
    } else if (isForce) {
      let token = this.tokenNumber && this.tokenNumber >= 1 ? (this.tokenDate + '-' + this.tokenNumber) : '';
      this.onEmitToken(token);
    }
  }

  onValidate(index) {
    this.message = '';
    switch (index) {
      case 1: {
        if (!this.tokenDate) {
          this.tokenDate = this.todayTokenDate;
        }
      } break;
      case 2: {
        // let onlyInteger = this.localService.getOnlyInteger(this.tokenNumber);
        // if (onlyInteger && onlyInteger.toString() != this.tokenNumber) {
        //   this.tokenNumber = onlyInteger.toString();
        // }
      } break;
      case 3: {
        let token = this.tokenNumber && this.tokenNumber >= 1 ? (this.tokenDate + '-' + this.tokenNumber) : '';
        this.onEmitToken(token);
      } break;
    }
  }

  onEmitToken(token: string) {
    this.onSearchToken.emit(token);
    if (this.isShowValidationMessage) {
      this.billingManagementService.getBillingIdByToken(this.businessId, token).subscribe(result => {
        this.isTokenAvailable = result && result.key && result.key != '';
        this.message = this.isTokenAvailable ? this.localService.languageContent.search_token.available : this.localService.languageContent.search_token.unavailable;
      });
    }
  }
}
